import { useTranslation } from 'react-i18next';

import { setLocale } from '@/i18n';
import { resolveLocaleWithinEnabled } from '@/i18n/display-locales';
import { isAppLocale, languageKeyForLocale } from '@/i18n/locales';
import { useEnabledDisplayLocales } from '@/i18n/useEnabledDisplayLocales';

import styles from './language-select.module.scss';

interface LanguageSelectProps {
  tone?: 'default' | 'inverse';
}

export function LanguageSelect({ tone = 'default' }: LanguageSelectProps) {
  const { t, i18n } = useTranslation();
  const enabledLocales = useEnabledDisplayLocales();
  if (enabledLocales.length <= 1) {
    return null;
  }
  const selectValue = resolveLocaleWithinEnabled(
    isAppLocale(i18n.language) ? i18n.language : null,
    enabledLocales
  );
  const className = tone === 'inverse' ? `${styles.select} ${styles.inverse}` : styles.select;
  return (
    <select
      className={className}
      aria-label={t('language.label')}
      value={selectValue}
      onChange={(event) => {
        const next = event.target.value;
        if (!isAppLocale(next) || !enabledLocales.includes(next) || next === selectValue) {
          return;
        }
        void setLocale(next).catch((error: unknown) => {
          console.error('Failed to change language', error);
        });
      }}
    >
      {enabledLocales.map((locale) => (
        <option key={locale} value={locale}>
          {t(languageKeyForLocale(locale))}
        </option>
      ))}
    </select>
  );
}
